import { potencyCodeMap } from "../constants/potency-code"
import { ITestClaimTransferPrescriptions } from "../types/interfaces/transfer-prescriptions"

export const getMedicationQuantityLabel = (medication: ITestClaimTransferPrescriptions) => {
    const originalQuantity = medication.copayQuantity || 30;
    const originalDaysSupply = medication.copayDaysSupply || 30;
    const potencyLabel = potencyCodeMap[medication.prescribable.potencyCode] || 'Unit';

    const monthlyQuantity = (originalQuantity * 100 * (30 / originalDaysSupply)) / 100;

    return `${monthlyQuantity} ${potencyLabel}${monthlyQuantity > 1 ? 's' : ''} 30 Days`;
}